module.exports = __webpack_public_path__ + "img/LATIN10_28.165f7b40.jpg";